import React, { useState, useEffect } from "react";

export const SearchBar = ({
  filters = {},
  setFilters,
  fields = [],
  onSearch,
}) => {
  const [localValues, setLocalValues] = useState({});

  // Initialize local state once or when filters change from an external reset
  useEffect(() => {
    const initialValues = {};
    fields.forEach((field) => {
      initialValues[field.key] = filters[field.key] ?? field.defaultValue ?? (field.type === "select" ? "All" : "");
    });
    setLocalValues(initialValues);
  }, [filters, fields]);

  const handleFilterChange = (key, value) => {
    setLocalValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Combine existing filters with current local input values
    const combinedValues = {
      ...filters,
      ...localValues,
    };

    if (setFilters) {
      setFilters(combinedValues);
    }

    if (onSearch) {
      onSearch(combinedValues);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="d-flex flex-wrap-nowrap gap-2 mb-4 align-items-center w-100"
    >
      {fields.map((field) => (
        <div className="col" key={field.key}>
          {field.type === "select" ? (
            <select
              className="status-select w-100"
              title={`Filter by ${field.label}`}
              value={localValues[field.key] !== undefined ? localValues[field.key] : (field.defaultValue ?? "All")}
              onChange={(e) => handleFilterChange(field.key, e.target.value)}
            >
              {field.options?.map((opt, idx) => {
                const isObject = typeof opt === "object" && opt !== null;
                const optionValue = isObject ? opt.value : opt;
                const optionLabel = isObject ? opt.label : opt;

                return (
                  <option key={idx} value={optionValue}>
                    {optionLabel}
                  </option>
                );
              })}
            </select>
          ) : (
            <input
              type="text"
              className="filter-input w-100"
              title={`Filter by ${field.label}`}
              placeholder={field.placeholder || `Search ${field.label}...`}
              value={localValues[field.key] ?? ""}
              onChange={(e) => handleFilterChange(field.key, e.target.value)}
            />
          )}
        </div>
      ))}

      <div className="col-auto">
        <button
          type="submit"
          className="btn btn-primary px-4 border-0 text-nowrap"
          style={{
            borderRadius: "8px",
            backgroundColor: "#0f172a",
            fontWeight: "600",
            fontSize: "0.85rem",
            whiteSpace: "nowrap",
          }}
        >
          <i className="bi bi-search me-2"></i>Search
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
